import { render, staticRenderFns } from "./multipleSelect.vue?vue&type=template&id=561f854e&scoped=true&"
import script from "./multipleSelect.vue?vue&type=script&lang=js&"
export * from "./multipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./multipleSelect.vue?vue&type=style&index=0&id=561f854e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f854e",
  null
  
)

export default component.exports